<template>
  <div class="pa-2">
    <div v-if="!itemSlug" class="d-flex flex-row justify-space-between">
      <div class="text-h5">RGP Companies Admin</div>
      <div>
        <v-btn depressed text :to="{ path: '/boss/rgp-companies/new' }"
          ><v-icon color="green" class="mr-1">mdi-plus</v-icon> Add
          Company</v-btn
        >
      </div>
    </div>
    <v-fade-transition>
      <generic-admin-list
        v-if="!itemSlug"
        idField="slug"
        title="RGP Companies"
        :headers="headers"
        api="rgpCompanies"
        editPath="/boss/rgp-companies"
        :refresh="refresh"
        itemsKey="items"
        actionField="name"
        @loaded="refresh = false"
        class="my-2"
      >
        <!--         detailPath="/rgp-companies/details/" -->
      </generic-admin-list>

      <edit-rgp-company
        v-else
        :slug="itemSlug"
        class="my-2"
        @cancel="itemSlug = null"
      >
      </edit-rgp-company>
    </v-fade-transition>
  </div>
</template>

<script>
import GenericAdminList from "@/components/adminStuff/GenericAdminList";
import EditRgpCompany from "./EditRgpCompany.vue";

export default {
  name: "RgpCompaniesAdminHome",
  components: { GenericAdminList, EditRgpCompany },
  props: {},
  data: function () {
    return {
      refresh: true,

      itemSlug: null,
      headers: [
        { value: "id", text: "Id" },
        { value: "name", text: "Company" },
        { value: "materialCount", text: "Materials" },
        { value: "lensCount", text: "Lenses" },
        { value: "display", text: "Display" },
      ],
    };
  },
  methods: {},
  computed: {},
  mounted() {
    this.itemSlug = this.$route?.params?.item ? this.$route.params.item : null;
    // this.getList();
  },
};
</script>

<style scoped></style>
